import { type i18n as I18n, type TFunction } from 'i18next';

import { Field } from '../dynamic-input-fields.type';

export const getPlaceholderText = (field: Field, t: TFunction, i18n: I18n) => {
  return i18n.exists(`${field.slug}FormFieldPlaceholder`) ? t(`${field.slug}FormFieldPlaceholder`) : field.name;
};
